import {Typography} from "antd";
import ResultListBox from "../ResultListBox";
import WinFormInput from "../WinFormInput";
import {useEffect} from "react";
import UIComponentHelper from "../UIComponentHelper";

export default function BridgeEditor({windowName, data, title, targetWindow, selectedBridge, onChangeBridge}) {

    const getBridgeData = ({bridge}) => {
        return data?.find(x => x.bridge_name === bridge) || {}
    }

    useEffect(() => {
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'coef_drag'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'pier_shape_k'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'submerged_inlet'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'submerged_inlet_outlet'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'max_low_chord'})
        UIComponentHelper.setStyleForRadio({targetWindow, windowName, name: 'use_method'})
        UIComponentHelper.setStyleForCheckbox({targetWindow, windowName, name: 'compute'})
        UIComponentHelper.setStyleForRadio({targetWindow, windowName, name: 'high_flow'})
    }, [data, selectedBridge]);

    return (
        <div style={{border: '1px solid #cfcfcf'}}>
            <Typography.Text style={{fontSize: '11pt', fontWeight: 'bold', backgroundColor: 'white', width: '100%', marginLeft: 4}}>
                Bridge Modeling Approach Editor - {title}
            </Typography.Text>
            <div style={{width: 450, backgroundColor: '#f5f5f5', fontSize: '9pt', padding: 4, paddingLeft: 4, paddingRight: 4}} id={windowName}>
                <ResultListBox
                    text={' '}
                    value={selectedBridge}
                    list={data?.map(x => x.bridge_name)}
                    onChange={(val) => onChangeBridge && onChangeBridge(val)}
                />

                <fieldset style={{border: '1px solid #a5a5a5', paddingLeft: 2, paddingRight: 2}}>
                    <legend style={{fontSize: '9pt', marginLeft: 4, paddingLeft: 4, width: 120}}>Low Flow Methods</legend>
                    <table style={{width: '100%'}}>
                        <tr>
                            <td style={{width: 30}}>
                                <div id={`${windowName}-use_method`}>
                                    Use
                                </div>
                            </td>
                            <td style={{width: 500}}>
                                <div id={`${windowName}-compute`}>
                                    Compute
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input name={`${windowName}-use_method-radio`} type={'radio'} readOnly={true} value={'0'} checked={getBridgeData({bridge: selectedBridge})?.use_method === 'Energy'}/>
                            </td>
                            <td>
                                <div style={{display: 'flex', gap: 4}}>
                                    <input name={`${windowName}-compute-checkbox`} type={'checkbox'} readOnly={true} value={'0'} checked={getBridgeData({bridge: selectedBridge})?.compute_methods?.includes('Energy')}/>
                                    <div>
                                        Energy (Standard Step)
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input name={`${windowName}-use_method-radio`} type={'radio'} readOnly={true} value={'1'} checked={getBridgeData({bridge: selectedBridge})?.use_method === 'Momentum'}/>
                            </td>
                            <td>
                                <div style={{display: 'flex', gap: 4}}>
                                    <input name={`${windowName}-compute-checkbox`} type={'checkbox'} readOnly={true} value={'0'} checked={getBridgeData({bridge: selectedBridge})?.compute_methods?.includes('Momentum')}/>
                                    <div style={{width: 200}}>
                                        Momentum
                                    </div>
                                    <div style={{width: 100}}>
                                        Coef Drag Cd
                                    </div>
                                    <div>
                                        <WinFormInput id={`${windowName}-coef_drag`}>
                                            {getBridgeData({bridge: selectedBridge})?.coef_drag}
                                        </WinFormInput>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input name={`${windowName}-use_method-radio`} type={'radio'} readOnly={true} value={'2'} checked={getBridgeData({bridge: selectedBridge})?.use_method === 'Yarnell'}/>
                            </td>
                            <td>
                                <div style={{display: 'flex', gap: 4}}>
                                    <input name={`${windowName}-compute-checkbox`} type={'checkbox'} readOnly={true} value={'0'} checked={getBridgeData({bridge: selectedBridge})?.compute_methods?.includes('Yarnell')}/>
                                    <div style={{width: 200}}>
                                        Yarnell (Class A Only)
                                    </div>
                                    <div style={{width: 100}}>
                                        Pier Shape K
                                    </div>
                                    <div>
                                        <WinFormInput id={`${windowName}-pier_shape_k`}>
                                            {getBridgeData({bridge: selectedBridge})?.pier_shape_k}
                                        </WinFormInput>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input name={`${windowName}-use_method-radio`} type={'radio'} readOnly={true} value={'3'} checked={getBridgeData({bridge: selectedBridge})?.use_method === 'WSPro'}/>
                            </td>
                            <td>
                                <div style={{display: 'flex', gap: 4}}>
                                    <input name={`${windowName}-compute-checkbox`} type={'checkbox'} readOnly={true} value={'0'} checked={getBridgeData({bridge: selectedBridge})?.compute_methods?.includes('WSPro')}/>
                                    <div>
                                        WS Pro Method (Class A Only)
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input name={`${windowName}-use_method-radio`} type={'radio'} readOnly={true} value={'4'} checked={getBridgeData({bridge: selectedBridge})?.use_method === 'Highest Energy'}/>
                            </td>
                            <td>
                                <span>
                                    Highest Energy
                                </span>
                            </td>
                        </tr>
                    </table>
                </fieldset>

                <fieldset style={{border: '1px solid #a5a5a5', paddingLeft: 2, paddingRight: 2}}>
                    <legend style={{fontSize: '9pt', marginLeft: 4, paddingLeft: 4, width: 120}}>High Flow Methods</legend>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input name={`${windowName}-high_flow-radio`} type={'radio'} readOnly={true} value={-1} checked={getBridgeData({bridge: selectedBridge})?.high_method === 'Energy Only'}/>
                        <label style={{marginLeft: 2}}>Energy Only (Standard Step)</label>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input name={`${windowName}-high_flow-radio`} type={'radio'} readOnly={true} value={0} checked={getBridgeData({bridge: selectedBridge})?.high_method === 'Pressure and/or Weir'}/>
                        <label style={{marginLeft: 2}}>Pressure and/or Weir</label>
                    </div>
                    <div style={{paddingLeft: 32}}>
                        <div style={{display: 'flex'}}>
                            <div style={{width: 220}}>
                                Submerged Inlet Cd. (Blank for Table)
                            </div>
                            <div>
                                <WinFormInput id={`${windowName}-submerged_inlet`}>
                                    {getBridgeData({bridge: selectedBridge})?.submerged_inlet}
                                </WinFormInput>
                            </div>
                        </div>
                        <div style={{display: 'flex'}}>
                            <div style={{width: 220}}>
                                Submerged Inlet + Outlet Cd
                            </div>
                            <div>
                                <WinFormInput id={`${windowName}-submerged_inlet_outlet`}>
                                    {getBridgeData({bridge: selectedBridge})?.submerged_inlet_outlet}
                                </WinFormInput>
                            </div>
                        </div>
                        <div style={{display: 'flex'}}>
                            <div style={{width: 220}}>
                                Max Low Chord (Blank for default)
                            </div>
                            <div>
                                <WinFormInput id={`${windowName}-max_low_chord`}>
                                    {getBridgeData({bridge: selectedBridge})?.max_low_chord}
                                </WinFormInput>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    )
}